import React from 'react';
import styled from 'styled-components';

const ToggleButton = styled.button`
  padding: 6px 12px;
  background: rgba(255,255,255,0.2);
  color: white;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  
  &:hover {
    background: rgba(255,255,255,0.3);
  }
`;

function SplitViewToggle({ splitView, onToggle }) {
  return (
    <ToggleButton onClick={onToggle}>
      {splitView ? '📝 Editor Only' : '⚡ Split View'}
    </ToggleButton>
  );
}

export default SplitViewToggle;
